var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('header-banner',{attrs:{"title":"会社案内"}}),_vm._v(" "),_c('table',{staticClass:"common-table"},[_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('th',[_vm._v(_vm._s(item.th))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.td))])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235c1c03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Company.vue
// module id = null
// module chunks = 